// Styles
import '../scss/index.scss';
import '/vendor/pages-v5/index';

$(document).ready(function () {
  $('.drop-categories__btn').on('click', function () {
    $('.header-categories__dropmenu').slideToggle();
  });

  $('.header-burger-menu').on('click', function () {
    $('.header-navigations').addClass('active');
    $('body').addClass('hidden');
  });

  $('.header-navigations__close').on('click', function () {
    $('.header-navigations').removeClass('active');
    $('body').removeClass('hidden');
  });
});

// accordion
document.addEventListener('DOMContentLoaded', () => {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach((header) => {
    const currentAccordionItem = header.closest('.accordion-item');
    const currentAccordionBody = currentAccordionItem.querySelector('.accordion-body');
    const currentAccordionIcon = header.querySelector('.accordion-icon');

    if (header.classList.contains('active')) {
      currentAccordionBody.style.maxHeight = currentAccordionBody.scrollHeight + 'px';
    } else {
      currentAccordionBody.style.maxHeight = '0';
    }

    header.addEventListener('click', () => {
      const isActive = header.classList.contains('active');
      accordionHeaders.forEach((otherHeader) => {
        const otherAccordionItem = otherHeader.closest('.accordion-item');
        const otherAccordionBody = otherAccordionItem.querySelector('.accordion-body');

        if (otherHeader.classList.contains('active')) {
          otherHeader.classList.remove('active');
          otherAccordionBody.classList.remove('show');
          otherAccordionBody.style.maxHeight = '0';
        }
      });

      if (!isActive) {
        header.classList.add('active');
        currentAccordionBody.classList.add('show');
        currentAccordionBody.style.maxHeight = currentAccordionBody.scrollHeight + 'px';
      } else {
      }
    });
  });

  const firstHeader = document.querySelector('.accordion-header');
  if (firstHeader) {
    if (!firstHeader.classList.contains('active')) {
      firstHeader.click();
    }
  }
});
